// IMPORTANTE IMPORTAR A DEPENDÊNCIA NO ARQUIVO INDEX.JS
import React, { createContext, useState } from "react";

export const DataAtualDMYContext = createContext()

export const DataAtualDMYContextProvider = ({children}) => {
    const [dataAtual, setDataAtualDMY] = useState()

    return (
        <DataAtualDMYContext.Provider value={{ dataAtual, setDataAtualDMY}}>
            {children}
        </DataAtualDMYContext.Provider>
    )
}